"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.UserAssignModal = void 0;
var tslib_1 = require("tslib");
var mobx_1 = require("mobx");
var autocomplete_menu_1 = require("../../components/autocomplete.menu/autocomplete.menu");
var input_1 = require("../../components/input/input");
var input_state_1 = require("../../components/input/input.state");
var modal_form_component_1 = require("../../components/modal.form/modal.form.component");
var spinner_1 = require("../../components/spinner/spinner");
var theme_1 = require("../../components/theme");
var i18n_1 = require("../../i18n");
var mithril_1 = require("../../mithril");
var services_1 = require("../../services");
var sort_1 = require("../../sort");
var userDisplayName_1 = require("../../util/userDisplayName");
var user_assign_modal_style_1 = require("./user.assign.modal.style");
var user_card_1 = require("./user.card");
(0, theme_1.addStyles)(user_assign_modal_style_1.Style);
var USER_ID_UNASSIGN = '$user_unassign$';
var UserAssignModal = /** @class */ (function (_super) {
    tslib_1.__extends(UserAssignModal, _super);
    function UserAssignModal(ctx, collections) {
        var _this = _super.call(this, ctx) || this;
        _this.assign = true;
        _this.collections = collections;
        _this.inputState = new input_state_1.InputState(i18n_1.T.ROLE_USER);
        _this.addState(_this.inputState);
        _this.menu = new autocomplete_menu_1.AutoCompleteMenu({
            inputState: _this.inputState,
            options: function () { return _this.userOptions; },
            optionView: function (option, nameParts) { return _this.viewUserCard(option, nameParts); },
            onselect: function (option) { return _this.selectUser(option); }
        });
        return _this;
    }
    Object.defineProperty(UserAssignModal.prototype, "loadingUsers", {
        get: function () {
            var users = services_1.Services.UserProfile.list;
            return users == null || users.length === 0;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(UserAssignModal.prototype, "userOptions", {
        get: function () {
            if (this.loadingUsers) {
                return [];
            }
            var options = [
                {
                    id: USER_ID_UNASSIGN,
                    value: (0, i18n_1.Translate)(i18n_1.T.COLLECTION_UNASSIGNED)
                }
            ];
            var users = services_1.Services.UserProfile.list;
            var sortedUsers = sort_1.IkeSort.byKey(users.slice(), ['firstname', 'lastname', 'username'], sort_1.IkeSort.ASC);
            for (var _i = 0, sortedUsers_1 = sortedUsers; _i < sortedUsers_1.length; _i++) {
                var user = sortedUsers_1[_i];
                options.push({
                    id: user.objectId,
                    value: (0, userDisplayName_1.userDisplayName)(user)
                });
            }
            return options;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(UserAssignModal.prototype, "nodes", {
        get: function () {
            if (this.loadingUsers) {
                return (0, mithril_1.m)('div', { className: user_assign_modal_style_1.CSS.container }, spinner_1.Spinner.view());
            }
            return (0, mithril_1.m)('div', { className: user_assign_modal_style_1.CSS.container }, [
                (0, mithril_1.m)('div', { className: user_assign_modal_style_1.CSS.content }, [
                    (0, mithril_1.m)('p', (0, i18n_1.Translate)(i18n_1.T.COLLECTION_ASSIGN_CONFIRM, { count: this.collections.length })),
                    this.viewInput()
                ]),
                (0, mithril_1.m)('div', { className: user_assign_modal_style_1.CSS.menu }, this.menu.view())
            ]);
        },
        enumerable: false,
        configurable: true
    });
    UserAssignModal.prototype.viewInput = function () {
        var _this = this;
        if (!this.assign) {
            return user_card_1.UserCardUnassigned.viewChip({
                cancel: function () { return _this.selectUser(); }
            });
        }
        if (this.userId == null) {
            return input_1.Input.view(this.inputState);
        }
        var user = services_1.Services.UserProfile.get(this.userId);
        return user_card_1.UserCard.viewChip(user, {
            cancel: function () { return _this.selectUser(); }
        });
    };
    UserAssignModal.prototype.canClose = function () {
        return _super.prototype.canClose.call(this) && !this.menu.isOpen();
    };
    UserAssignModal.prototype.viewUserCard = function (option, nameParts) {
        var _this = this;
        if (option.id === USER_ID_UNASSIGN) {
            return {
                view: user_card_1.UserCardUnassigned.view(nameParts),
                action: function () { return _this.unassignUser(); }
            };
        }
        var user = services_1.Services.UserProfile.get(option.id);
        if (user == null) {
            return null;
        }
        var me = services_1.Services.User.current;
        var cardCtx = {
            me: me != null && user.objectId === me.objectId
        };
        return {
            view: user_card_1.UserCard.view(user, nameParts, cardCtx),
            action: function () { return _this.selectUser(option); }
        };
    };
    UserAssignModal.prototype.validate = function () {
        if (!this.assign) {
            this.inputState.setError('');
            return;
        }
        if (this.userId == null) {
            this.inputState.setError(i18n_1.T.USER_ASSIGN_REQUIRED);
        }
        else {
            this.inputState.setError('');
        }
    };
    UserAssignModal.prototype.submit = function () {
        if (this.assign) {
            return services_1.Services.Collection.assign(this.collections, this.userId);
        }
        return services_1.Services.Collection.assign(this.collections, null);
    };
    UserAssignModal.prototype.selectUser = function (option) {
        if (option != null) {
            this.userId = option.id;
            this.inputState.setValue(option.value);
            this.inputState.setDisabled(true);
        }
        else {
            this.userId = null;
            this.inputState.setValue('');
            this.inputState.setDisabled(false);
        }
        this.assign = true;
    };
    UserAssignModal.prototype.unassignUser = function () {
        this.selectUser(null);
        this.assign = false;
    };
    tslib_1.__decorate([
        mobx_1.observable
    ], UserAssignModal.prototype, "userId", void 0);
    tslib_1.__decorate([
        mobx_1.observable
    ], UserAssignModal.prototype, "assign", void 0);
    tslib_1.__decorate([
        mobx_1.computed
    ], UserAssignModal.prototype, "loadingUsers", null);
    tslib_1.__decorate([
        mobx_1.computed
    ], UserAssignModal.prototype, "userOptions", null);
    tslib_1.__decorate([
        mobx_1.action
    ], UserAssignModal.prototype, "selectUser", null);
    tslib_1.__decorate([
        mobx_1.action
    ], UserAssignModal.prototype, "unassignUser", null);
    return UserAssignModal;
}(modal_form_component_1.ModalFormComponent));
exports.UserAssignModal = UserAssignModal;
//# sourceMappingURL=user.assign.modal.js.map